import type { AxiosError } from 'axios'

export function formatApiError(err: unknown, fallback: string): string {
  const axiosErr = err as AxiosError<{ detail?: unknown; error?: string }>
  const data = axiosErr.response?.data
  if (data?.error && typeof data.error === 'string') return data.error

  const detail = data?.detail
  if (typeof detail === 'string' && detail.trim()) return detail
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === 'string') return item
        if (item && typeof item === 'object' && 'msg' in item) {
          return String((item as { msg?: string }).msg ?? '')
        }
        return ''
      })
      .filter(Boolean)
      .join(' ')
  }

  if (!axiosErr.response) {
    if (axiosErr.code === 'ECONNABORTED') return fallback
    return fallback
  }

  const status = axiosErr.response.status
  if (status === 401) return 'Not authenticated'
  if (status === 403) return 'Forbidden'
  if (status === 429) return 'Too many requests'
  if (status >= 500) return fallback

  return fallback
}
